<template>
  <v-container fluid xl>
    <v-flex xs12 sm8 offset-sm2>
      <form id="search-form" @submit.prevent="submitQuery">
        <textarea
          onload="this.focus()"
          v-model="userQuery"
          class="inputarea2"
          label="Enter your query"
          name="q"
          type="text"
          required
          @keyup.enter="submitQuery"
        ></textarea>
        <v-btn type="submit">Submit</v-btn>
      </form>
      <div class="user-query animated-bg">
        <p>{{ userQuery }}</p>
      </div>
      <div class="results animated-bg">
        <div v-for="(result, index) in results" :key="index">
          <p v-html="highlightLinks(result.text)"></p>
        </div>
      </div>
    </v-flex>
  </v-container>
</template>


<script>
import axios from 'axios';
export default {
data() {
  return {
    userQuery: "",
    results: [],
    conversationHistory: [],
  };
},
methods: {
  readOutLoud: (msg) => {
    const speech = new SpeechSynthesisUtterance();
    const voiceName = 'Google UK English Male';
    speech.volume = 1;
    speech.rate = 1;
    speech.pitch = 1;
    speech.voice = speechSynthesis.getVoices().filter(function (voice) {
    return voice.name === voiceName
  })[0]
    speech.text = msg;
    window.speechSynthesis.speak(speech);

    speech.onend = function() {
    setTimeout(() => {
      Event.$emit('speakModeOn');
    }, 4000);
   };
  },
  async submitQuery() {
if (!this.userQuery) return;
this.prompt = `YOUR COMMAND: ${this.userQuery}`;
this.results.push({ text: `User Query: ${this.userQuery}` }); // Add user query to the results array

try {
  const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ message: this.userQuery }),
  });
  const content = await response.json();

  let message = content.message.replace(/AI/g, "").replace(/:/g, "").trim();
  this.results.push({ text: `Generated AI: ${message}` });
  this.$store.commit('this.updateMessage', { message });   
      this.readOutLoud(message);
  // Execute command using handleConcierge function
  if (message.includes("concierge")) {
    const conciergeResults = await this.handleConcierge(message);
    this.results.push({ text: `Results: ${JSON.stringify(conciergeResults.searchResults)}` });
    this.results.push({ text: `Confirmation: ${conciergeResults.message}` });
  }
  // Execute command using handleConcierge function
if (this.userQuery.includes("concierge")) {
  const conciergeResults = await this.handleConcierge();
  this.results.push({ text: `Results: ${JSON.stringify(conciergeResults.searchResults)}` });
  // Do other necessary actions with conciergeResults (e.g., confirmation)
}
  // Store conversation
  const date = new Date().toISOString();
  this.storeConversation(date, this.results);
} catch (err) {
  console.log(err);
}
},
handleConcierge: async function(msg) {
// Initialize the Crawler
const crawler = new this.Crawler();

// Visit Google and perform a search
crawler.go_to_page("https://www.google.com/search?q=" + msg.replace("concierge", ""));

// Capture the search results
const searchResultsSelector = ".g";
const searchResults = await crawler.page.$$eval(searchResultsSelector, (results) => {
  return results.map((result) => {
    const title = result.querySelector("h3")?.textContent || "";
    const link = result.querySelector("a")?.href || "";
    const snippet = result.querySelector(".IsZvec")?.textContent || "";

    return { title, link, snippet };
  });
});

// Send search results to the server for further processing
const response = await axios.post(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
  searchResults,
});

// Close the browser instance
await crawler.browser.close();

// Return the server response
return response.data;
},

  storeConversation(date, content) {
    const storedConversations = JSON.parse(localStorage.getItem("conversations")) || [];
    storedConversations.push({ date, content });
    localStorage.setItem("conversations", JSON.stringify(storedConversations));
  },
  highlightLinks(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, url => `<a href="${url}" target="_blank" class="active-link">${url}</a>`);
},
},
mounted() {
  const storedConversations = JSON.parse(localStorage.getItem("conversations"));
  if (storedConversations) {
    this.conversationHistory = storedConversations;
  }
},
};
</script>

<style scoped src="../components/css/Style.css">
@import '../components/css/Style.css';
@import url('https://fonts.googleapis.com/css2?family=Coda:wght@400;800&display=swap');

</style>

<style>
.user-query {
position: sticky;
background-color: #f5f5f5;
border-radius: 20px;
padding: 1rem;
margin-bottom: 1rem;
width: 45%;
float: left;
}
.inputarea2 {
width: 100%;
height: 100%;
overflow: auto;
scroll-margin-bottom: 10px;
padding: 12px 20px;
box-sizing: border-box;
border: 2px solid #ccc;
border-radius: 4px;
background-color: #f8f8f8;
font-size: 16px;
resize: none;
}
.results {
position: sticky;
background-color: #f5f5f5;
border-radius: 20px;
padding: 1rem;
margin-bottom: 1rem;
width: 45%;
float: right;
}
.active-link {
color: blue;
text-decoration: underline;
cursor: pointer;
}

@keyframes animated-background {
0% { background-position: 0 0; }
100% { background-position: 100% 0; }
}
.animated-bg {
background: linear-gradient(45deg,  #192b4469, #0f172453, #0004174d);
background-size: 200% 100%;
animation: animated-background 20s linear infinite;
}
</style>